var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.6667H28",
    stroke: "#4D7CB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.66668C22.5304 4.13625 23.2499 3.83826 24 3.83826C24.3714 3.83826 24.7392 3.91142 25.0824 4.05356C25.4256 4.1957 25.7374 4.40404 26 4.66668C26.2626 4.92933 26.471 5.24113 26.6131 5.58429C26.7553 5.92745 26.8284 6.29525 26.8284 6.66668C26.8284 7.03812 26.7553 7.40592 26.6131 7.74908C26.471 8.09224 26.2626 8.40404 26 8.66668L9.33333 25.3334L4 26.6667L5.33333 21.3334L22 4.66668Z",
    stroke: "#4D7CB5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit3);
export default __webpack_public_path__ + "static/media/edit-3.f492559f58b54a288dc333927f8ddb9b.svg";
export { ForwardRef as ReactComponent };